import { Box, Button, Chip, Typography } from "@mui/material";
// import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { styled } from "@mui/system";
import { Instance } from "../../../../types/whatsapp";
import { useMemo } from "react";
import { Store } from "../../../../types/whatsapp";

const DOTT = (
  <Box component="span" sx={{ mx: "0.5rem", transform: "scale(1)" }}>
    •
  </Box>
);

const TypographyStyled = styled(Typography)({
  display: "flex",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "26px",
});

const ButtonStyled = styled(Button)({
  color: "#616161",
  border: "1px solid #B0B0B0",
  "&:hover": { border: "1px solid #B0B0B0" },
});

interface PropsInstance {
  instance: Instance;
  stores?: Store[];
  loadingDisconnect: boolean;
  onQrCode: () => void;
  onEdit: () => void;
  onDisconnect: () => void;
  // onDelete: () => void;
}

export function InstanceBox({
  instance: { nome, shared_instance, own_number, id_loja, id },
  stores,
  loadingDisconnect,
  onQrCode,
  onEdit,
  onDisconnect,
}: // onDelete,
PropsInstance) {
  const store: Store | undefined = useMemo(() => {
    if (stores && id_loja) {
      const findStore: Store | undefined = stores.find(
        (store) => store.id_loja === id_loja
      );
      return findStore;
    }
  }, [id_loja, stores]);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      borderBottom="1px solid #F2F3F5"
      borderTop="1px solid #F2F3F5"
      py="0.6rem"
    >
      <Box>
        <TypographyStyled>
          {id} - {nome}
        </TypographyStyled>
        <TypographyStyled fontSize="12px" color="#616161">
          {store?.nome_loja && store?.nome_loja} ({id_loja})
          {store?.nome_loja && Boolean(own_number) && DOTT}
          {Boolean(own_number) && own_number}
        </TypographyStyled>

        <Chip
          label={shared_instance ? "Conectada" : "Desconectada"}
          size={"small"}
          sx={{
            padding: "0px 0.5rem",
            gap: "0.625rem",
            borderRadius: "0.25rem",
            lineHeight: "22px",
            letterSpacing: "0.05rem",
            fontSize: "12px",
            background: shared_instance ? "#52C41A" : "#B02F2F",
            "& .MuiChip-label": {
              padding: 0,
              color: "#FFF",
            },
          }}
        />
      </Box>
      <Box display="flex" p={0} alignItems="center" gap="1rem">
        {/* <ButtonStyled
          variant="outlined"
          sx={{ width: "2.5rem", height: "2.5rem", padding: 0 }}
          onClick={onDelete}
        >
          <DeleteOutlineOutlinedIcon />
        </ButtonStyled> */}

        <ButtonStyled variant="outlined" onClick={onEdit}>
          Configurar
        </ButtonStyled>

        <Button
          variant="contained"
          disabled={loadingDisconnect}
          sx={{ width: "8.2rem" }}
          onClick={() => {
            shared_instance ? onDisconnect() : onQrCode();
          }}
        >
          {loadingDisconnect
            ? "Desconectando"
            : shared_instance
            ? "Desconectar"
            : "Reconectar"}
        </Button>
      </Box>
    </Box>
  );
}
